(function () {
  'use strict';
  if (window.__o16CatVideoAutoplay) return;
  window.__o16CatVideoAutoplay = true;

  var SEL = '.categories-list__video video';

  // iOS Safari fallback: autoplay is often blocked (esp. Low Power Mode); the
  // first real user gesture is allowed to call play(). Arms only after an
  // actual autoplay rejection, so it is a no-op when autoplay just works.
  var catFallbackRegistered = false;
  function registerCatFallback() {
    if (catFallbackRegistered) return;
    catFallbackRegistered = true;
    function resumeVisible() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      document.querySelectorAll(SEL).forEach(function (v) {
        if (!v.paused) return;
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh) { v.play().catch(function () {}); }
      });
    }
    document.addEventListener('touchend', resumeVisible, { once: true, passive: true });
    document.addEventListener('click', resumeVisible, { once: true, passive: true });
  }

  function safePlay(v) {
    if (!v.paused) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () { registerCatFallback(); });
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          safePlay(v);
        } else if (!v.paused) {
          // Pause off-screen collection videos so they don't stream while the
          // page's hero video is loading (they resume on scroll-in).
          v.pause();
        }
      });
    }, { threshold: 0.15 });
  }

  function init(root) {
    (root || document).querySelectorAll(SEL).forEach(function (v) {
      if (v.dataset.o16CatInit) return;
      v.dataset.o16CatInit = '1';
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      if (observer) {
        observer.observe(v);
      } else {
        safePlay(v); // no IntersectionObserver support -> keep original always-play behaviour
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
